import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { requestApi } from '../../core/modules/form/utilities'
//import { requestApi } from './utilities'
import FormHeader from '../../core/modules/form/cformheader'
import { bindActionCreators } from 'redux'
import { snackbarMessage } from '../../core/actions';
import { connect } from 'react-redux';
import { getEnvVariable } from '../../modules/environmentalList';
import FormDropdown from '../../core/modules/form/cformdropdown';
import SearchIcon from '@material-ui/icons/Search';
import Fab from '@material-ui/core/Fab';
import { Grid, GridColumn, GridColumnMenuFilter, GridToolbar } from '@progress/kendo-react-grid';
import { CustomColumnMenu } from '../../core/modules/Grid/customColumnMenu';
import ForwardIcon from '@material-ui/icons/Forward';
import { createRequest, requestApi as requestApiNew } from '../../core/controls/helpers/rest';
const _ = require('lodash');

//comment
class AssosciateInquiryForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sitepermittypedropval: [],
            sitepermittype: 'All',
            sitepermitsubtypedropval: [],
            subtypes: [],
            sitepermitsubtype: null,
            sitepermittypestatusdropval: [],
            sitepermittypestatus: null,
            data: [],
            selecteddata: [],
            total: null,
            disable:true
        };
    }
    componentDidMount() {
        let read = {
            get: {
                url: getEnvVariable('AdminConfig') + `/api/SitePermitTypes/SubModuleKey/Active`
            }
        }
        let readurl = {
            get: {
                url: getEnvVariable('Application') + `/api/Domains/values?domainkey=INQUIRIES_SUB_TYPE`
            }
        }
     
        requestApi(read).then(res => {
            console.log(res);
            this.handleSearch();
            let dropval = [{ Name: 'All', Id: 'All', IsDefault: "Y" }]
            let dropdowndata = res.filter(each => each.SubModuleKey === "INQUIRIES")
            dropval = [...dropval, ...dropdowndata]
            this.setState({ sitepermittypedropval: dropval })
        })

        requestApi(readurl).then(res => {
            console.log(res);
            this.setState({ subtypes: res })
        })

  

      
    }

getStatusDropDown = (e) => {
    let readstatusurl = {
        post: {
            url: getEnvVariable('Application') + `/api/DomainsMapper/ByParams/1?autoComplete=true`
        }
    }
    let readsitepermittypestatusurl = {
        get: {
            url: getEnvVariable('Application') + `/api/SitePermitTypesStatus/BySitePermitTypeId/${e.target.value}`
        }
    }
    requestApi(readstatusurl, null, { module: "INQUIRIES", SITE_PERMIT_TYPE: this.props.match.params.routeid }, null, true).then(res => {
        console.log(res);
        let allstatus = res['APPLICATION_STATUS']
        requestApi(readsitepermittypestatusurl).then(res => {
            let result = []
            let permitstatuses = res
            for (let bItem of allstatus) {
                for (let aItem of permitstatuses) {
                  if (bItem.value === String(aItem.SelectedStatus.Id)) {
                    result.push(bItem);
                    break;
                  }
                }
              }
              this.setState({ sitepermittypestatusdropval: result })
        })
       
    })
}

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.dataItem != this.props.dataItem) {
            this.didmountinitialload();
        }

    }


    handleBack = () => {
        this.props.onClose();
    }

    handleFieldChange = (e) => {
        this.setState({ [e.target.name]: e.target.value }, () => {
            if (e.target.name == 'sitepermittype') {
                this.setState({ sitepermittypestatus: null, sitepermitsubtype: null })
                if (e.target.value != 'All') {
                    this.getSubtypesbyid(e);
                    this.getStatusDropDown(e);
                }
            }
        })

    }

    handleSearch = () => {
        // let readurl = getEnvVariable('MasterAdmin') + `/api/InternalUser/MPS/Grid?page=1&pageSize=20`

        // requestApi(readurl).then(res => {
        //     console.log(res);
        //     this.setState({ subtypes: res })
        // })
        let search = this.state.sitepermittype != 'All' ? {
            post: {
                url: getEnvVariable('Application') + `/api/Application/DynamicSearchGrid/INQUIRIES/${this.state.sitepermittype}?page=1&pageSize=20`
            }
        } : {
            get: {
                url: getEnvVariable('Application') + `/api/Application/AssociateInquiriesSearch/INQUIRIES`
            }
        }
        let resdata = { "SITE_PERMIT_TYPE": this.state.sitepermittype, "APPLICATION_STATUS": this.state.sitepermittypestatus, 'REQUEST_TYPE': this.state.sitepermitsubtype }
        const filteredObject = Object.keys(resdata).reduce((acc, key) => {
            if (resdata[key] !== null) {
              acc[key] = resdata[key];
            }
            return acc;
          }, {});
          console.log(filteredObject)
        let searchresult = this.state.sitepermittype != 'All' ? { "searchParams": filteredObject, "operator": "and", "IsQuickSearch": "N" } : {}
        requestApi(search, null, searchresult, null, true).then(res => {
            console.log(res);
           
                console.log(res);
                let selectDataValues = []
                res && res.data && res.data.forEach(element => {
                    selectDataValues.push({ ...element, selected: false })
                });

                this.setState({ data: selectDataValues })
            
        })
    }

    handleForward = () => {
        let gridData = [...this.state.data]
        let selectedItems = gridData.filter(item => item.selected === true).map(item => ({
            ...item,
            status: 'A'
          }));
          
          console.log(selectedItems);
          let requesturl = {
            post: {
                url: getEnvVariable('Sidebar') + `/api/AssociateInquiries/${this.props.match.params.routeid1}/Add`
            }
        }
        requestApi(requesturl, null, selectedItems, null, false, 'Forwarded successfully').then(res => {
            console.log(res);
            this.props.onClose();
        })
    }

    headerSelectionChange = (event) => {
        console.log(event)
        let gridData = [...this.state.data]
        const allSelectedTrue = gridData.every(item => item.selected === true);
        if (allSelectedTrue) {
            gridData.forEach(item => {
                item.selected = false;
            });
        }
       else {
            gridData.forEach(item => {
                item.selected = true;
            });
        }
        let selectedItemsData = gridData.filter(item => item.selected === true).map(item => ({
            ...item,
          }));
        //  this.setState({ data: gridData})
        this.setState({ data: gridData, disable : selectedItemsData && selectedItemsData.length>0 ? false : true})
    }

    selectionChange = (event) => {
        let targetId = event.dataItem.Id
        let gridData = [...this.state.data]
        for (let i = 0; i < gridData.length; i++) {
            if (gridData[i].Id === targetId) {
                gridData[i].selected = !gridData[i].selected;
                break;
            }
        }
        console.log(gridData);
        let selectedItemsData = gridData.filter(item => item.selected === true).map(item => ({
            ...item,
          }));
        //  this.setState({ data: gridData})
        this.setState({ data: gridData, disable : selectedItemsData && selectedItemsData.length>0 ?  false : true})
    }

    getSubtypesbyid = (event) => {
        let subtypelist;
        let filteredArray;
        let suburl = getEnvVariable('AdminConfig') + `/api/SitePermitTypesConfig/` + event.target.value + `/Get`
        if (this.state.subtypes && event.target.value) {
            let arrayUrl =
                [
                    { url: suburl, type: 'get' },
                ]
            Promise.all(arrayUrl.map(each => requestApiNew(createRequest(each)))).then(res => {
                subtypelist = res[0] && res[0].subTypes.split(",");
                const filteredArray = this.state.subtypes.filter((element) => {
                    return subtypelist.includes(element.Value);
                });
                this.setState({ sitepermitsubtypedropval: filteredArray });
            }).catch(ex => {
                console.error(ex)
            })
        }
    }

    render() {
        const { options, defaults, order, type, compmap, className, styles, accessPermissions, accessLevelPermissions, dataItem, onFullScreen, onExitFullScreen, fullscreen, exitfullscreen, onNextItemClick, onPrevItemClick, ...otherProps } = this.props;
        let selectData = this.state.data
        let gridColumns = [
            {
                "title": "Record ID",
                "field": "Id",
                "show": true,
                "width": 200,
            },
            {
                "title": "Permit Type",
                "field": "Application TypeDesc",
                "show": true,
                "width": 200,
            },
            {
                "title": "Permit Sub Type",
                "field": "Request TypeDesc",
                "show": true,
                "width": 200,
            },
            {
                "title": "Permit Status",
                "field": "Application StatusDesc",
                "show": true,
                "width": 200,
            },

        ]
        return (
            <Fragment>
                <div>
                    <FormHeader title="Add Assosciate Inquiries" backbutton={true} handleBack={this.handleBack}
                        onFullScreen={onFullScreen} onExitFullScreen={onExitFullScreen} fullscreen={fullscreen} exitfullscreen={exitfullscreen} />
                    <div class="pl-3 pt-3 pr-2">
                        <div className='row'>
                            <div className='col-sm-6'>
                                <FormDropdown
                                    dropdownvalues={this.state.sitepermittypedropval}
                                    name='sitepermittype'
                                    label='Permit Type'
                                    value={this.state.sitepermittype}
                                    handleFieldChange={(e) => this.handleFieldChange(e)}
                                    edit={true}
                                    transformProps={{
                                        name: 'Name',
                                        value: 'Id'
                                    }}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <FormDropdown
                                    dropdownvalues={this.state.sitepermitsubtypedropval}
                                    name='sitepermitsubtype'
                                    label='Permit Sub Type'
                                    value={this.state.sitepermitsubtype}
                                    handleFieldChange={(e) => this.handleFieldChange(e)}
                                    edit={true}
                                    disabled={this.state.sitepermittype == 'All' ? true : false}
                                    transformProps={{
                                        name: 'Name',
                                        value: 'Value'
                                    }}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <FormDropdown
                                    dropdownvalues={this.state.sitepermittypestatusdropval}
                                    name='sitepermittypestatus'
                                    label='Permit Status'
                                    value={this.state.sitepermittypestatus}
                                    handleFieldChange={(e) => this.handleFieldChange(e)}
                                    edit={true}
                                    disabled={this.state.sitepermittype == 'All' ? true : false}
                                    transformProps={{
                                        name: 'name',
                                        value: 'value'
                                    }}
                                />
                            </div>
                            <div className='pt-2'>
                                <Fab title="Search" onClick={() => this.handleSearch()} size="small" color='primary' variant='contained'><SearchIcon /></Fab>
                            </div>
                            <div className='pl-2 pt-2'>
                            <Fab title="Add Associate Inquiries" onClick={() => this.handleForward()} disabled = {this.state.disable} size="small" color= {this.state.disable ? 'inherit' : 'primary'} variant='contained'><ForwardIcon /></Fab>
                        </div>
                        </div>
                        
                        <div className='pt-3'>
                            <Grid
                                reorderable
                                total={this.state.total}
                                data={this.state.data}
                                onRowClick={false}
                                resizable
                                selectedField="selected"
                                onSelectionChange={this.selectionChange}
                                onHeaderSelectionChange={this.headerSelectionChange}
                            >
                                <GridColumn
                                    className="selected"
                                    field="selected"
                                    width="75px"
                                    headerSelectionValue={
                                        selectData && selectData.length > 0 && selectData.findIndex(dataItem => dataItem.selected === false) === -1

                                    } />
                                {gridColumns && gridColumns.length > 0 && gridColumns.map((each, index) => {
                                    return <GridColumn {...each}
                                        filter={each.filter}
                                        key={index}
                                        width={each.width}
                                        columnMenu={
                                            props =>
                                                <CustomColumnMenu
                                                    {...props}
                                                    columns={gridColumns}
                                                />
                                        } />
                                })}
                            </Grid>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

}

const mapActions = dispatch => {
    return bindActionCreators({ snackbarMessage }, dispatch);
}

AssosciateInquiryForm = connect(null, mapActions)(AssosciateInquiryForm)
export default withRouter(AssosciateInquiryForm)
